import React from 'react';
import { Interpolate } from 'react-i18next';
import { openSettingsDialog } from '../../actions/open-settings-dialog';

export const POST_RESTORE = 'post-restore';
export const POST_MOVE_TO_TRASH = 'post-move-to-trash';
export const POST_DELETE = 'post-delete';
export const POST_DELETE_ANOTHER_WRITER_EDITING_ERROR = 'post-delete-another-writer-editing-error';
export const POST_SUBSCRIBED = 'post-subscribe';
export const POST_UNSUBSCRIBED = 'post-unsubscribe';
export const POST_ENABLE_COMMENTING = 'post-enable-commenting';
export const POST_DISABLE_COMMENTING = 'post-disable-commenting';
export const POST_PUBLISH = 'post-publish';
export const POST_UPDATE = 'post-update';
export const POST_REVERTED_TO_DRAFT = 'post-reverted-to-draft';
export const POST_MOVE = 'post-move';
export const POST_PIN = 'post-pin';
export const POST_UNPIN = 'post-unpin';

export const DRAFT_MOVE_TO_TRASH = 'draft-move-to-trash';
export const UNSCHEDULE = 'unschedule';

export const COMMENT_DELETE = 'comment-delete';

export const REQUIRE_POST_FIELDS = 'require-post-fields';

export const DEMO_MODE_SITE = 'demo-mode-site';
export const DEMO_MODE_EDITOR = 'demo-mode-editor';
export const DEMO_MODE_PREVIEW = 'demo-mode-preview';

export const SETTINGS_UPDATED = 'settings-updated';

export default {
  [POST_MOVE_TO_TRASH]: {
    content: () => <Interpolate i18nKey="messages.post-moved-to-trash" />,
    type: 'success',
    messageKey: 'messages.post-moved-to-trash',
  },
  [POST_PIN]: {
    content: () => <Interpolate i18nKey="messages.post-pinned" />,
  },
  [POST_UNPIN]: {
    content: () => <Interpolate i18nKey="messages.post-unpinned" />,
  },
  [POST_DELETE]: {
    content: () => <Interpolate i18nKey="messages.post-deleted" />,
    type: 'success',
    messageKey: 'messages.post-deleted',
  },
  [POST_DELETE_ANOTHER_WRITER_EDITING_ERROR]: {
    content: () => <Interpolate i18nKey="messages.post-delete-another-writer-editing-error" />,
    type: 'error',
    messageKey: 'messages.post-delete-another-writer-editing-error',
  },
  [POST_PUBLISH]: {
    content: () => <Interpolate i18nKey="messages.post-published" />,
    type: 'success',
    messageKey: 'messages.post-published',
    linkMessageKey: 'messages.post-published-link',
  },
  [POST_REVERTED_TO_DRAFT]: {
    content: () => <Interpolate i18nKey="messages.post-reverted-to-draft" />,
    type: 'success',
    messageKey: 'messages.post-reverted-to-draft',
  },
  [POST_UPDATE]: {
    content: () => <Interpolate i18nKey="messages.post-updated" />,
    type: 'success',
    messageKey: 'messages.post-updated',
  },
  [POST_ENABLE_COMMENTING]: {
    content: () => <Interpolate i18nKey="messages.commenting-enabled" />,
    type: 'info',
    messageKey: 'messages.commenting-enabled',
  },
  [POST_DISABLE_COMMENTING]: {
    content: () => <Interpolate i18nKey="messages.commenting-disabled" />,
    type: 'info',
    messageKey: 'messages.commenting-disabled',
  },
  [DRAFT_MOVE_TO_TRASH]: {
    content: () => <Interpolate i18nKey="messages.draft-moved-to-trash" />,
    type: 'success',
    messageKey: 'messages.draft-moved-to-trash',
  },
  [UNSCHEDULE]: {
    content: () => <Interpolate i18nKey="messages.unschedule" />,
    type: 'success',
    messageKey: 'messages.unschedule',
  },
  [POST_SUBSCRIBED]: {
    content: () => <Interpolate i18nKey="messages.post-subscribed" />,
  },
  [POST_UNSUBSCRIBED]: {
    content: () => <Interpolate i18nKey="messages.post-unsubscribed" />,
  },
  [POST_MOVE]: {
    content: () => <Interpolate i18nKey="messages.post-moved" />,
  },
  [COMMENT_DELETE]: {
    content: () => <Interpolate i18nKey="messages.comment-deleted" />,
  },

  [REQUIRE_POST_FIELDS]: {
    content: (data) => {
      const key = data && data.sort().join('-');
      switch (key) {
        case 'title':
          return <Interpolate i18nKey="messages.post-title-required" />;
        case 'content':
          return <Interpolate i18nKey="messages.post-content-required" />;
        default:
          return <Interpolate i18nKey="messages.post-fields-required" />;
      }
    },
    type: 'error',
  },

  [DEMO_MODE_SITE]: {
    content: () => <Interpolate i18nKey="messages.demo-mode-site" />,
    type: 'info',
  },
  [DEMO_MODE_EDITOR]: {
    content: () => <Interpolate i18nKey="messages.demo-mode-editor" />,
    type: 'info',
  },
  [DEMO_MODE_PREVIEW]: {
    content: (t, dispatch) => (
      <Interpolate
        i18nKey="messages.demo-mode-preview"
        activate={
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => dispatch(openSettingsDialog())}
          >
            {t('messages.demo-mode-preview-activate')}
          </span>
        }
      />
    ),
    type: 'info',
  },
  [SETTINGS_UPDATED]: {
    content: () => <Interpolate i18nKey="messages.settings-saved" />,
    type: 'success',
    messageKey: 'messages.settings-saved',
  },
};
